import type { Theme } from '@/themes/types'

const defaultTheme: Theme = {
  baseHeight: '3.75rem',
  colors: {
    primary: '#228753',
    secondary: '#115D36',
    score: '#ffffff',
    text: '#ffffff',
    textDark: '#2B2B2A',
    background: 'transparent',
    backgroundOverlay: 'rgba(26, 26, 26, 0.85)',
    blackout: '#2B2B2A',
    homeTeamDefault: '#33B8F8',
    awayTeamDefault: '#FF9A28',
  },
}

export default defaultTheme
